/**
 * Auth API methods — thin typed wrappers around the gateway proxies.
 *
 * Every method returns a discriminated success/error union via
 * `apiJson` + `ApiError`. The store layer (zustand) consumes these
 * and surfaces error codes to react-i18next.
 *
 * Password reset is intentionally NOT exposed — CHAOS is an internal
 * tool for the founder + named team members, password rotation happens
 * out-of-band via founder direct DB access (ADR-053 v1.1).
 */
import type {
  AuthSessionResponse,
  LoginRequest,
  MeResponse,
  SignupRequest,
} from '@chaos/types/auth';

import { apiJson } from './client';

export const authApi = {
  signup(payload: SignupRequest): Promise<AuthSessionResponse> {
    return apiJson<AuthSessionResponse>('/auth/signup', { method: 'POST', json: payload });
  },

  login(payload: LoginRequest): Promise<AuthSessionResponse> {
    return apiJson<AuthSessionResponse>('/auth/login', { method: 'POST', json: payload });
  },

  logout(): Promise<{ ok: boolean }> {
    return apiJson<{ ok: boolean }>('/auth/logout', { method: 'POST' });
  },

  me(): Promise<MeResponse> {
    return apiJson<MeResponse>('/auth/me');
  },

  refresh(): Promise<{ accessToken: string }> {
    return apiJson<{ accessToken: string }>('/auth/refresh', { method: 'POST', json: {} });
  },
};
